export const inviteLinksChartOptions = [
    { value: 'subscribedCount', label: 'Вступлений' },
    { value: 'budget', label: 'Бюджет' },
    { value: 'reach', label: 'Охват' },
    { value: 'CTR', label: 'CR, %' },
    { value: 'CPM', label: 'CPM, ₽' },
    { value: 'CPS', label: 'CPS, ₽' },
    { value: 'unsubscribedCount', label: 'Отписки' },
    { value: 'unsubscriptionPercentage', label: 'Отписки, %' },
    { value: 'total_CPS', label: 'Итого CPS, ₽' },
    { value: 'totalSubscribed', label: 'Итого вступлений' },

] as const

export type InviteLinksChartType =
    (typeof inviteLinksChartOptions)[number]['value']

export interface InviteLinksChartOptionType {
    value: InviteLinksChartType
    label: string
}

export const typedInviteLinksChartOptions: readonly InviteLinksChartOptionType[] =
    inviteLinksChartOptions
